<template>
  <li width="100%">
    <div class="product_img" style="margin:10px">
      <a style="cursor:pointer"
      ><img :src="product.img_url"/></a>
      <div v-for="(soldout) in soldoutList" :key="soldout">
        <span v-show="soldout == product.item_sku" class="soldout">일시품절</span>
      </div>
      
    </div>
    <div class="product_text_info">
      <p class="product_title">
        <span
          class
        >{{ product.item_name }}</span> / <span
          class
        ><template
          v-if="isDoubleX(product.item_sku)"
        >{{ product.count * 3 }}{{ product.display }} ({{ product.count }}세트)</template><template
          v-else
        >{{ product.count }}{{ product.display }}</template></span>
      </p>
      <div class="hashtag_list">
        <span
          v-for="hash in product.item_hashes"
          :key="hash"
        >#{{ hash }} </span>
      </div>
    </div>
  </li>
</template>

<script>
import doubleXMixin from '@/components/global/doublex-mixin';

export default {
  name: 'PopupProductItemInfoDetail',
  mixins: [doubleXMixin],
  props: {
    product: {
      type: Object,
      default: () => ({}),
    },
    soldoutList: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
  },
  created() {
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/modal-popups/PopupProductsItemInfoDetail.vue